module.exports = __webpack_public_path__ + "assets/img/play-free-now.badcce45.png";